export enum SettingsPageTabs {
  INFORMATION = 'information',
  PRICING = 'pricing',
  SETTINGS = 'settings',
  WORKING_DAYS = 'working_days',
  EVENT_SCHEDULE = 'event_schedule',
  RESTRICTIONS = 'restrictions',
  COMMUNICATION = 'communication',
  SMS = 'sms',
  DELETION = 'deletion',
  WIDGET = 'widget',
  INTEGRATION = 'integration',
}
